import {
  createStyles,
  Fade,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core'
import React, { useState } from 'react'
import Button from '../Button/Button'
import Commitment from '../Commitment/Commitment'
import TextField from '../TextField/TextField'
import { connect } from 'react-redux'
import { forgetPassword } from '../../redux/actions/user'
import clsx from 'clsx'
import Loader from '../Loader/Loader'
import { prismicText } from '../Global/CMSText'

const useStyles = makeStyles((theme) =>
  createStyles({
    loginForm: {},
    loginFormCard: {
      padding: theme.spacing(3, 2, 2),
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      margin: theme.spacing(0, 2),
      [theme.breakpoints.up('sm')]: {
        maxWidth: 400,
        margin: 'auto',
      },
    },
    loginFormCardFunnel: {
      padding: theme.spacing(2),
    },
    alignCenter: {
      textAlign: 'center',
    },
    form: {
      width: '70%',
      margin: 'auto',
    },
    link: {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    forgot: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    alignLeft: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
    },
    marginBottom: {
      marginBottom: theme.spacing(2),
    },
    success: {
      color: theme.palette.success.main,
    },
    hide: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
  })
)

type Tprops = {
  text: any
  switchForm: any
  isFunnel: boolean
  t: any
  forgetPassword: any
}

const mapStateToProps = (state) => ({
  user: state.user,
})

const mapDispatchToProps = {
  forgetPassword: forgetPassword,
}

const ForgotPasswordForm = ({
  isFunnel,
  text,
  switchForm,
  forgetPassword,
  t,
}: Tprops) => {
  const classes = useStyles()
  const [email, setEmail] = useState('')
  const [hasSend, setHasSend] = useState(false)
  const [error, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const submitForm = async (e) => {
    e.preventDefault()
    setHasSend(false)
    setHasError(false)
    setIsLoading(true)
    const forgotReq = await forgetPassword(email)
    if (forgotReq.type === 'FORGET_PASSWORD_FAILURE') {
      setHasError(true)
      setHasSend(false)
      setIsLoading(false)
    } else {
      setHasSend(true)
      setHasError(false)
      setIsLoading(false)
    }
  }

  return (
    <Fade in>
      <div
        className={
          !isFunnel
            ? `account-card forgot-card ${classes.loginFormCard}`
            : `account-form forgot-form ${classes.loginForm}`
        }
      >
        <Typography
          variant={'h3'}
          align={'center'}
          className={`account__title ${classes.marginBottom}`}
        >
          <b>
            {prismicText(text?.forget_title, t('texts:account:forget_title'))}
          </b>
        </Typography>
        <div className={clsx(isFunnel && classes.loginFormCardFunnel)}>
          <Typography
            variant={'body1'}
            className={clsx(classes.alignCenter, classes.marginBottom)}
          >
            <b>
              {prismicText(
                text?.forget_subtitle,
                t('texts:account:forget_subtitle')
              )}
            </b>
          </Typography>
          <form onSubmit={submitForm}>
            <div className={clsx(classes.form, classes.marginBottom)}>
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <TextField
                    type={'email'}
                    name={'email'}
                    required
                    label={prismicText(
                      text?.login_email,
                      t('texts:account:email')
                    )}
                    placeholder={prismicText(
                      text?.login_email,
                      t('texts:account:email')
                    )}
                    value={email}
                    onChange={setEmail}
                  />
                </Grid>
              </Grid>
            </div>
            <div className={clsx(classes.alignCenter, classes.marginBottom)}>
              <Button
                variant={'contained'}
                color={'secondary'}
                disabled={email === '' || isLoading}
                type={'submit'}
                className={'account-forgot__btn'}
              >
                <span className={isLoading ? classes.hide : classes.show}>
                  {prismicText(text?.button_recup, t('account:button_recup'))}
                </span>
                {isLoading && <Loader />}
              </Button>
            </div>
          </form>
          {hasSend && (
            <div className={clsx(classes.alignCenter, classes.marginBottom)}>
              <Typography
                variant={'body2'}
                color={'secondary'}
                className={clsx('account__success', classes.success)}
              >
                {t('texts:account:email_send')}
              </Typography>
            </div>
          )}
          {error && (
            <div className={clsx(classes.alignCenter, classes.marginBottom)}>
              <Typography
                variant={'body2'}
                color={'error'}
                className={clsx('account__error')}
              >
                {t('texts:account:email_not_send')}
              </Typography>
            </div>
          )}
          <div className={clsx(classes.alignCenter, classes.marginBottom)}>
            <Typography
              variant={'body2'}
              className={clsx('account__back', classes.link)}
            >
              <span onClick={() => switchForm(4)}>
                {prismicText(
                  text?.to_login_link,
                  t('texts:account:to_login_link')
                )}
              </span>
            </Typography>
          </div>
          {text?.is_displayed_on_forgot_password_form && (
            <Commitment
              icon={
                text?.protected_data_image?.url
                  ? text?.protected_data_image?.url
                  : null
              }
              title={prismicText(
                text?.title_data,
                t('texts:account:title_data')
              )}
              desc={prismicText(text?.text_data, t('texts:account:text_data'))}
              center={false}
            />
          )}
        </div>
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm)
